// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3SCnA","link":"style_link__1j9YV"};